<p-dialog [header]="'upgradeDialog.upgradeToPro' | transloco" [modal]="true" [(visible)]="upgradeDialogVisible" [style]="{'width': '400px'}" (onHide)="closeDialog()">
  <div class="p-4">
    <div class="fs-5">
      <i class="fa fa-warning text-danger me-2"></i>
      {{ 'upgradeDialog.freePlanArtTypeLimitReached' | transloco }}
    </div>
    <hr />
    <div class="mt-2">
      <div class="text-muted">
        {{ 'upgradeDialog.artTypeLimitMessage' | transloco: { numberOfArtTypeSelection: numberOfArtTypeSelection } }}
      </div>
    </div>

    <div class="mt-3 d-flex justify-content-end">
      <button pButton type="button" [label]="'upgradeDialog.upgradeNow' | transloco" class="p-button p-button-outlined p-button-sm"(click)="ShowUpgradeDailog()"></button>
    </div>
  </div>
</p-dialog>

@if (isStripeDisplayPlansDialogVisible) {
  <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
    [stripeAllPlans]="stripePlans"
  (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)"></stripe-payment-plan>
}